<template>
  <div v-if="tableData.length > 0" class="list-content col-12">
      <vue3-datatable
          ref="resultTable"
          :rows="tableData"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="100%"
          :sortable="true"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
      >
      </vue3-datatable>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'ContractorVehicleResults',
    mixins: [restApi, timeUtils],
    components: {Vue3Datatable},
    props: {
        results: {
            type: Array
        }
    },
    data: function () {
        return {
            fields: [
                {field: 'make', title: this.$t('vehicle_list.make'), sort: false,headerClass: 'routa-table-header'},
                {field: 'vehicle_model', title: this.$t('vehicle_list.model'), sort: false,headerClass: 'routa-table-header'},
                {field: 'license_plate', title: this.$t('vehicle_defects.license_plate'), sort: false,headerClass: 'routa-table-header'},
                {field: 'inspection_status', title: this.$t('contractor_reports.inspection_status'), sort: false,headerClass: 'routa-table-header', width: '5em',
                    cellRenderer: (item) => {
                        let cellClass = 'cell-container'
                        if (item._cellVariants['inspection_status']) {
                            cellClass += ' ' + item._cellVariants['inspection_status']
                        }
                        return '<div class="'+cellClass+'">' + item['inspection_status'] + '</div>'
                    }
                }
            ],
            tableData: []
        }
    },
    mounted() {
        this.initializeData()
    },
    methods: {
        getRowClass(row) {
            return row.id === this.selectedRowId ? 'routa-table-row selected-row row-id-' + row.id : 'routa-table-row  row-id-' + row.id
        },

        initializeData() {
            this.tableData = []
            const temp = []
            this.results.forEach(vehicle => {
                let tableRow = []
                let cellVariants = {}
                tableRow['make'] = vehicle.make
                tableRow['vehicle_model'] = vehicle.vehicle_model
                tableRow['license_plate'] = vehicle.license_plate
                tableRow['inspection_status'] = vehicle.inspection_status ? this.$t('common.ok') : this.$t('contractor_reports.inspection_missing')
                if (!vehicle.inspection_status) {
                    cellVariants['inspection_status'] = 'cell-danger'
                } else {
                    cellVariants['inspection_status'] = 'cell-success'
                }
                tableRow['_cellVariants'] = cellVariants
                temp.push(tableRow)
            })
            this.$nextTick(() => this.tableData = temp)
        }
    }
}
</script>
